import { inject } from '@angular/core';
import { CanMatchFn, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { BffUserService, roleGuard } from '@canvas/four-r-digital';
import { InvalidPermissionsComponent } from './invalid-permissions/invalid-permissions.component';
import { Roles } from './auth/roles';
import { DashboardPageComponent } from './modules/finance/pages/dashboard/dashboard-page.component';
import { environment } from '../environments/environment';

const devAuthBypass = () => environment.useFakeLogin;

const financeRoleGuard: CanMatchFn = (route, segments) => {
  if (environment.useFakeLogin) {
    return true;
  }

  return roleGuard(route, segments);
};

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
    canMatch: [devAuthBypass],
  },
  {
    path: '',
    component: LoginComponent,
    canMatch: [
      () =>
        environment.useFakeLogin
          ? false
          : inject(BffUserService).isNotAuthenticated(),
    ],
  },
  {
    path: 'dashboard',
    component: DashboardPageComponent,
    canMatch: [financeRoleGuard],
    data: { role: Roles.FinanceInvestor },
  },
  {
    path: 'assets',
    canMatch: [financeRoleGuard],
    data: { role: Roles.FinanceInvestor },
    loadComponent: () =>
      import('./modules/finance/pages/assets/assets-page.component').then(
        (m) => m.AssetsPageComponent
      ),
  },
  {
    path: 'payments',
    canMatch: [financeRoleGuard],
    data: { role: Roles.FinanceInvestor },
    loadComponent: () =>
      import('./modules/finance/pages/payments/payments-page.component').then(
        (m) => m.PaymentsPageComponent
      ),
  },
  { path: 'forbidden', component: InvalidPermissionsComponent },
  { path: '**', redirectTo: 'dashboard' },
];
